import * as React from "react";
const SvgChevronDown = props => <svg xmlns="http://www.w3.org/2000/svg" width={18} height={10} fill="none" viewBox="0 0 18 10" {...props}><path fill="currentColor" d="M2.2.3A1 1 0 0 0 .8 1.7L9 9.92l8.2-8.2A1 1 0 0 0 15.8.29L9 7.1z" /></svg>;
export default SvgChevronDown;